export default function(to, from, savedPosition) {
      if (to.name === from.name || from.name.includes('olympiad-filter') && to.name.includes('olympiad-filter')) {
        return false; // Не скроллить
      }
      // Иначе стандартное поведение
      return savedPosition || { x: 0, y: 0 };
    }
